var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:_vm.classes,attrs:{"align":_vm.align,"colspan":_vm.colspan}},[(_vm.column.type == 'empty')?[_c('span')]:(_vm.column.slot)?[_c('tg-table-slot',{attrs:{"column":_vm.column,"row":_vm.row}})]:[_c('span',[_vm._v(_vm._s(_vm.columnValue))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }